var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"id":"newCompanies"}},_vm._l((_vm.allEntries),function(entry,i){return _c('NewCompaniesRow',{key:i,attrs:{"entry":entry},on:{"click":function($event){return _vm.showDetails(entry)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }